import Marionette from 'backbone.marionette';
import journalHomeLayoutTmpl from '../templates/journal_home_layout.tpl';
export default Marionette.LayoutView.extend({
  template: journalHomeLayoutTmpl,
  regions: {
    legislativeDayRegion: "#legislative-day-region",
    dailyVotesRegion: "#daily-votes-region",
    dailyEventsRegion: "#daily-events-region",
    meetingScheduleRegion: "#meeting-schedule-region"
  }
});